import { render, staticRenderFns } from "./ComplaintStatistic.vue?vue&type=template&id=41a25796"
import script from "./ComplaintStatistic.vue?vue&type=script&lang=js"
export * from "./ComplaintStatistic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports